import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logoImg from "../assets/NMT3.png"
import {
  faPhone,
  faEnvelope,
  faMessage,
  faLocationDot,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faYoutube,
  faTwitter,
  faInstagram,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer
      style={{
        background:" linear-gradient(to bottom, #f8f9fa, #e9f5ff)",
        color: "#333",
        fontFamily: "'Poppins', sans-serif",
        padding: 0,
        margin: 0,
        width: "100%",
        boxShadow: "0 -5px 30px rgba(0, 0, 0, 0.05)",
      }}
    >
      {/* Main Footer Content */}
      <div
        className="footer-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "40px",
          padding: "60px 5%",
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* Company Info */}
        <div>
          <h3 style={headingStyle}>NMT INDIA</h3>
          <p style={paragraphStyle}>
            NMT INDIA offers exciting customizable packages to spectacular
            destinations. We aim to create harmony between travelers and
            industry professionals.
          </p>
          {/* <div style={{ marginTop: "20px" }}>
            <img 
              src="/logoImg" 
              alt="NMT India Logo"
              style={{ 
                maxWidth: "180px",
                height: "auto",
                filter: "drop-shadow(0 2px 5px rgba(0,0,0,0.1))"
              }} 
            />
          </div> */}
        </div>

        {/* Quick Links */}
        <div>
          <h3 style={headingStyle}>Quick Links</h3>
          <ul className="quick-links" style={linkListStyle}>
            {[
              "Destinations",
              "Experiences",
              "Activities",
              "International Tours",
              "Domestic Tours",
              "Group Tours",
              "FAQs",
              "Review Us",
            ].map((item) => (
              <li key={item} style={linkItemStyle}>
                <a href="#" style={linkStyle}>
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    style={arrowIconStyle}
                  />
                  <span style={{ position: "relative" }}>
                    {item}
                    <span style={hoverUnderlineStyle}></span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Popular Destinations */}
        <div>
          <h3 style={headingStyle}>Popular Tours</h3>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {[
              "Europe Highlights",
              "Asian Adventure",
              "American Dream",
              "African Safari",
              "Middle East Explorer",
              "Island Getaway",
            ].map((tour) => (
              <li key={tour} style={{ marginBottom: "12px" }}>
                <a href="#" style={linkStyle}>
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    style={arrowIconStyle}
                  />
                  <span style={{ position: "relative" }}>
                    {tour}
                    <span style={hoverUnderlineStyle}></span>
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 style={headingStyle}>Contact Info</h3>
          <ul style={{ listStyle: "none", padding: 0 }}>
            <li style={iconListItem}>
              <div style={iconWrapperStyle}>
                <FontAwesomeIcon icon={faPhone} style={iconStyle} />
              </div>
              <a href="tel:+919697988891" style={contactLinkStyle}>
                +91 9697988893 <br/>
                +91 9697988891
              </a>
            </li>
            <li style={iconListItem}>
              <div style={iconWrapperStyle}>
                <FontAwesomeIcon icon={faEnvelope} style={iconStyle} />
              </div>
              <a
                href="https://travelwitheducation.com"
                target="_blank"
                rel="noopener noreferrer"
                style={contactLinkStyle}
              >
                info@nmtindiaholidays.com
              </a>
            </li>
            <li style={iconListItem}>
              <div style={iconWrapperStyle}>
                <FontAwesomeIcon icon={faMessage} style={iconStyle} />
              </div>
              <a href="tel:+919697988891" style={contactLinkStyle}>
                +91 9697988892 <br/>
                +91 9697988894
              </a>
            </li>
            <li style={{ display: "flex", alignItems: "flex-start", marginBottom: "12px" }}>
              <div style={iconWrapperStyle}>
                <FontAwesomeIcon icon={faLocationDot} style={iconStyle} />
              </div>
              <span style={contactTextStyle}>
               Office No.106/107, First Floor, Shiv Platino, Opp. Khare Mangal Karyalaya Parking, Vishrambag, Sangli 416 415 (MS) INDIA  </span>
            </li>
          </ul>

          <div style={{ marginTop: "25px" }}>
            <h4 style={{ marginBottom: "15px", color: "#31378f", fontSize: "16px" }}>
              Follow Us
            </h4>
            <div style={{ display: "flex", gap: "12px" }}>
              {[
                { icon: faFacebookF, color: "#3b5998" },
                { icon: faTwitter, color: "#1da1f2" },
                { icon: faInstagram, color: "#e1306c" },
                { icon: faYoutube, color: "#ff0000" },
                { icon: faLinkedinIn, color: "#0077b5" },
              ].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  className="social-icon"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    backgroundColor: social.color,
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div
        style={{
          background:" #2193b0",
          color: "white",
          padding: "10px 5%",
          textAlign: "center",
          borderTop: "1px solid rgba(255,255,255,0.1)",
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "14px",
              opacity: 0.9,
            }}
          >
            &copy; {new Date().getFullYear()} NMT India || All rights reserved.
          </p>
          <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
            <a href="#" style={{ color: "white", opacity: 0.8, fontSize: "13px" }}>Privacy Policy</a>
            <a href="#" style={{ color: "white", opacity: 0.8, fontSize: "13px" }}>Terms of Service</a>
            <a href="#" style={{ color: "white", opacity: 0.8, fontSize: "13px" }}>Sitemap</a>
          </div>
        </div>
      </div>

      <style jsx>{`
        .quick-links {
          columns: 2;
          gap: 20px;
        }
        
        a:hover {
          color: #31378f !important;
        }
        
        .social-icon:hover {
          transform: translateY(-3px) scale(1.1);
          box-shadow: 0 6px 12px rgba(0,0,0,0.15) !important;
        }
        
        @media (max-width: 900px) {
          .footer-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 30px !important;
          }
          
          .quick-links {
            columns: 1 !important;
          }
        }
        
        @media (max-width: 600px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            padding: 40px 8% !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </footer>
  );
};

const headingStyle = {
  color: "#2193b0",
  fontSize: "20px",
  marginBottom: "25px",
  position: "relative",
  paddingBottom: "12px",
  fontWeight: "600",
};

const paragraphStyle = {
  marginBottom: "20px",
  lineHeight: "1.7",
  color:" #080808ff",
  fontSize: "15px",
};

const linkListStyle = {
  listStyle: "none",
  padding: 0,
};

const linkItemStyle = {
  marginBottom: "12px",
  breakInside: "avoid",
};

const linkStyle = {
  color:" #080808ff",
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  transition: "all 0.3s ease",
  fontSize: "15px",
};

const hoverUnderlineStyle = {
  position: "absolute",
  bottom: "-2px",
  left: 0,
  width: "0",
  height: "2px",
  background:" #2193b0",
  transition: "width 0.3s ease",
};

const arrowIconStyle = {
  color: "#2193b0",
  marginRight: "10px",
  fontSize: "12px",
  transition: "transform 0.3s ease",
};

const iconListItem = {
  marginBottom: "15px",
  display: "flex",
  alignItems: "center",
};

const iconWrapperStyle = {
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  backgroundColor: "rgba(49, 55, 143, 0.1)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "12px",
  flexShrink: 0,
};

const iconStyle = {
  color: "#2193b0",
  fontSize: "14px",
};

const contactLinkStyle = {
  color:" #080808ff",
  textDecoration: "none",
  transition: "all 0.3s ease",
  fontSize: "15px",
};

const contactTextStyle = {
  color:" #080808ff",
  fontSize: "15px",
  lineHeight: "1.5",
};

export default Footer;

































// import React from 'react';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPhone,
//   faEnvelope,
//   faMessage,
//   faLocationDot,
//   faArrowRight,
//   faEdit,
//   faTrash
// } from "@fortawesome/free-solid-svg-icons";
// import {
//   faFacebookF,
//   faYoutube,
//   faTwitter,
//   faInstagram,
//   faLinkedinIn,
// } from "@fortawesome/free-brands-svg-icons";

// const Footer = ({ footerData, isAdmin = false, onEdit, onDelete }) => {
//   return (
//     <footer className="footer-container">
//       {/* Main Footer Content */}
//       <div className="footer-grid">
//         {/* Company Info */}
//         <div className="footer-section">
//           <div className="section-header">
//             <h3 className="footer-heading">{footerData.companyInfo.title}</h3>
//             {isAdmin && (
//               <div className="admin-controls">
//                 <button onClick={() => onEdit('companyInfo')} className="edit-btn">
//                   <FontAwesomeIcon icon={faEdit} />
//                 </button>
//                 <button onClick={() => onDelete('companyInfo')} className="delete-btn">
//                   <FontAwesomeIcon icon={faTrash} />
//                 </button>
//               </div>
//             )}
//           </div>
//           <p className="footer-text">{footerData.companyInfo.description}</p>
//           <div className="logo-container">
//             <img 
//               src={footerData.companyInfo.logo} 
//               alt="Company Logo"
//               className="footer-logo" 
//             />
//           </div>
//         </div>

//         {/* Quick Links */}
//         <div className="footer-section">
//           <div className="section-header">
//             <h3 className="footer-heading">{footerData.quickLinks.title}</h3>
//             {isAdmin && (
//               <div className="admin-controls">
//                 <button onClick={() => onEdit('quickLinks')} className="edit-btn">
//                   <FontAwesomeIcon icon={faEdit} />
//                 </button>
//                 <button onClick={() => onDelete('quickLinks')} className="delete-btn">
//                   <FontAwesomeIcon icon={faTrash} />
//                 </button>
//               </div>
//             )}
//           </div>
//           <ul className="quick-links">
//             {footerData.quickLinks.links.map((link, index) => (
//               <li key={index} className="link-item">
//                 <a href={link.url} className="footer-link">
//                   <FontAwesomeIcon icon={faArrowRight} className="link-icon" />
//                   <span className="link-text">{link.text}</span>
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Popular Tours */}
//         <div className="footer-section">
//           <div className="section-header">
//             <h3 className="footer-heading">{footerData.popularTours.title}</h3>
//             {isAdmin && (
//               <div className="admin-controls">
//                 <button onClick={() => onEdit('popularTours')} className="edit-btn">
//                   <FontAwesomeIcon icon={faEdit} />
//                 </button>
//                 <button onClick={() => onDelete('popularTours')} className="delete-btn">
//                   <FontAwesomeIcon icon={faTrash} />
//                 </button>
//               </div>
//             )}
//           </div>
//           <ul className="tour-links">
//             {footerData.popularTours.tours.map((tour, index) => (
//               <li key={index} className="tour-item">
//                 <a href={tour.url} className="footer-link">
//                   <FontAwesomeIcon icon={faArrowRight} className="link-icon" />
//                   <span className="link-text">{tour.name}</span>
//                 </a>
//               </li>
//             ))}
//           </ul>
//         </div>

//         {/* Contact Info */}
//         <div className="footer-section">
//           <div className="section-header">
//             <h3 className="footer-heading">{footerData.contactInfo.title}</h3>
//             {isAdmin && (
//               <div className="admin-controls">
//                 <button onClick={() => onEdit('contactInfo')} className="edit-btn">
//                   <FontAwesomeIcon icon={faEdit} />
//                 </button>
//                 <button onClick={() => onDelete('contactInfo')} className="delete-btn">
//                   <FontAwesomeIcon icon={faTrash} />
//                 </button>
//               </div>
//             )}
//           </div>
//           <ul className="contact-list">
//             <li className="contact-item">
//               <div className="contact-icon">
//                 <FontAwesomeIcon icon={faPhone} />
//               </div>
//               <a href={`tel:${footerData.contactInfo.phone1}`} className="contact-link">
//                 {footerData.contactInfo.phone1}
//               </a>
//             </li>
//             <li className="contact-item">
//               <div className="contact-icon">
//                 <FontAwesomeIcon icon={faEnvelope} />
//               </div>
//               <a href={footerData.contactInfo.website} className="contact-link" target="_blank" rel="noopener noreferrer">
//                 {footerData.contactInfo.website}
//               </a>
//             </li>
//             <li className="contact-item">
//               <div className="contact-icon">
//                 <FontAwesomeIcon icon={faMessage} />
//               </div>
//               <a href={`tel:${footerData.contactInfo.phone2}`} className="contact-link">
//                 {footerData.contactInfo.phone2}
//               </a>
//             </li>
//             <li className="contact-item">
//               <div className="contact-icon">
//                 <FontAwesomeIcon icon={faLocationDot} />
//               </div>
//               <span className="contact-text">{footerData.contactInfo.address}</span>
//             </li>
//           </ul>

//           <div className="social-media">
//             <h4 className="social-title">Follow Us</h4>
//             <div className="social-icons">
//               {footerData.socialMedia.map((social, index) => (
//                 <a
//                   key={index}
//                   href={social.url}
//                   className="social-icon"
//                   style={{ backgroundColor: social.color }}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <FontAwesomeIcon icon={social.icon} />
//                 </a>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer Bottom */}
//       <div className="footer-bottom">
//         <div className="footer-bottom-content">
//           <p className="copyright">
//             &copy; {new Date().getFullYear()} {footerData.copyrightText}
//           </p>
//           <div className="footer-links">
//             {footerData.bottomLinks.map((link, index) => (
//               <a key={index} href={link.url} className="footer-bottom-link">
//                 {link.text}
//               </a>
//             ))}
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .footer-container {
//           background: linear-gradient(135deg, #f8f9fa 0%, #e9f5ff 100%);
//           color: #333;
//           font-family: 'Poppins', sans-serif;
//           width: 100%;
//           box-shadow: 0 -5px 30px rgba(0, 0, 0, 0.05);
//         }
        
//         .footer-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 40px;
//           padding: 60px 5%;
//           max-width: 1400px;
//           margin: 0 auto;
//         }
        
//         .footer-section {
//           position: relative;
//         }
        
//         .section-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 15px;
//         }
        
//         .admin-controls {
//           display: flex;
//           gap: 10px;
//         }
        
//         .edit-btn, .delete-btn {
//           background: transparent;
//           border: none;
//           cursor: pointer;
//           font-size: 14px;
//           transition: all 0.3s ease;
//         }
        
//         .edit-btn {
//           color: #4CAF50;
//         }
        
//         .delete-btn {
//           color: #F44336;
//         }
        
//         .edit-btn:hover, .delete-btn:hover {
//           transform: scale(1.1);
//         }
        
//         .footer-heading {
//           color: #31378f;
//           font-size: 20px;
//           margin-bottom: 0;
//           padding-bottom: 12px;
//           font-weight: 600;
//           position: relative;
//         }
        
//         .footer-heading::after {
//           content: '';
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           width: 50px;
//           height: 2px;
//           background-color: #31378f;
//         }
        
//         .footer-text {
//           margin-bottom: 20px;
//           line-height: 1.7;
//           color: #555;
//           font-size: 15px;
//         }
        
//         .logo-container {
//           margin-top: 20px;
//         }
        
//         .footer-logo {
//           max-width: 180px;
//           height: auto;
//           filter: drop-shadow(0 2px 5px rgba(0,0,0,0.1));
//         }
        
//         .quick-links, .tour-links {
//           list-style: none;
//           padding: 0;
//           columns: 2;
//           gap: 20px;
//         }
        
//         .link-item, .tour-item {
//           margin-bottom: 12px;
//           break-inside: avoid;
//         }
        
//         .footer-link {
//           color: #444;
//           text-decoration: none;
//           display: flex;
//           align-items: center;
//           transition: all 0.3s ease;
//           font-size: 15px;
//           position: relative;
//         }
        
//         .link-icon {
//           color: #31378f;
//           margin-right: 10px;
//           font-size: 12px;
//           transition: transform 0.3s ease;
//         }
        
//         .footer-link:hover {
//           color: #31378f !important;
//         }
        
//         .footer-link:hover .link-icon {
//           transform: translateX(3px);
//         }
        
//         .link-text::after {
//           content: '';
//           position: absolute;
//           bottom: -2px;
//           left: 0;
//           width: 0;
//           height: 2px;
//           background-color: #31378f;
//           transition: width 0.3s ease;
//         }
        
//         .footer-link:hover .link-text::after {
//           width: 100%;
//         }
        
//         .contact-list {
//           list-style: none;
//           padding: 0;
//         }
        
//         .contact-item {
//           margin-bottom: 15px;
//           display: flex;
//           align-items: center;
//         }
        
//         .contact-icon {
//           width: 36px;
//           height: 36px;
//           border-radius: 50%;
//           background-color: rgba(49, 55, 143, 0.1);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-right: 12px;
//           flex-shrink: 0;
//           color: #31378f;
//           font-size: 14px;
//         }
        
//         .contact-link, .contact-text {
//           color: #444;
//           font-size: 15px;
//           transition: all 0.3s ease;
//         }
        
//         .contact-link {
//           text-decoration: none;
//         }
        
//         .contact-link:hover {
//           color: #31378f !important;
//         }
        
//         .contact-text {
//           line-height: 1.5;
//         }
        
//         .social-media {
//           margin-top: 25px;
//         }
        
//         .social-title {
//           margin-bottom: 15px;
//           color: #31378f;
//           font-size: 16px;
//         }
        
//         .social-icons {
//           display: flex;
//           gap: 12px;
//         }
        
//         .social-icon {
//           width: 36px;
//           height: 36px;
//           border-radius: 50%;
//           color: white;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 14px;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//         }
        
//         .social-icon:hover {
//           transform: translateY(-3px) scale(1.1);
//           box-shadow: 0 6px 12px rgba(0,0,0,0.15) !important;
//         }
        
//         .footer-bottom {
//           background: linear-gradient(to bottom, #023e8a, #0077b6);
//           color: white;
//           padding: 10px 5%;
//           text-align: center;
//           border-top: 1px solid rgba(255,255,255,0.1);
//         }
        
//         .footer-bottom-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//         }
        
//         .copyright {
//           margin: 0;
//           font-size: 14px;
//           opacity: 0.9;
//         }
        
//         .footer-links {
//           display: flex;
//           gap: 20px;
//           margin-top: 10px;
//         }
        
//         .footer-bottom-link {
//           color: white;
//           opacity: 0.8;
//           font-size: 13px;
//           text-decoration: none;
//           transition: opacity 0.3s ease;
//         }
        
//         .footer-bottom-link:hover {
//           opacity: 1;
//         }
        
//         @media (max-width: 900px) {
//           .footer-grid {
//             grid-template-columns: repeat(2, 1fr);
//             gap: 30px;
//           }
          
//           .quick-links {
//             columns: 1;
//           }
//         }
        
//         @media (max-width: 600px) {
//           .footer-grid {
//             grid-template-columns: 1fr;
//             padding: 40px 8%;
//             gap: 40px;
//           }
          
//           .footer-links {
//             flex-direction: column;
//             gap: 8px;
//           }
//         }
//       `}</style>
//     </footer>
//   );
// };

// export default Footer;